import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './index.css';
import { APP_BUILD_ID } from './buildInfo';
import App from './App';
import store from './store';
import theme from './theme';
import { DashboardProjectFocusProvider } from './context/DashboardProjectFocusContext';
import { registerServiceWorker } from './utils/registerServiceWorker';
import { initPwaInstallCapture } from './utils/pwaInstall';
import ErrorBoundary from './components/common/ErrorBoundary';

// Fingerprint deploys: changing CACHEBUST at image build forces new hashed bundles in Docker/CI.
if (typeof window !== 'undefined') {
    window.__TESTGATE_APP_BUILD__ = APP_BUILD_ID;
}

initPwaInstallCapture();
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <DashboardProjectFocusProvider>
                    <ThemeProvider theme={theme}>
                        <CssBaseline />
                        <ErrorBoundary>
                            <App />
                        </ErrorBoundary>
                        <ToastContainer
                            position="top-center"
                            autoClose={3000}
                            hideProgressBar={false}
                            newestOnTop
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                            style={{ top: 'calc(12px + env(safe-area-inset-top))' }}
                        />
                    </ThemeProvider>
                </DashboardProjectFocusProvider>
            </BrowserRouter>
        </Provider>
    </React.StrictMode>
);
